import React from "react";
import { DIVISION_COLOR } from "@/lib/constants";

// Recursive node for OrgChartVisual. Uses React.createElement for the self-reference
// to avoid a Babel "Maximum call stack size exceeded" bug with recursive JSX components.
// Design: dark indigo box with role_title (top) → separator → person name (bottom),
// mimicking a traditional printed org chart.
function OrgChartNode({ node, q, canManage, onSelect, depth = 0, viewerId, canSeeAllLevels = true }) {
  const matches = !q || (node.name || "").toLowerCase().includes(q) || (node.role_title || "").toLowerCase().includes(q) || (node.division || "").toLowerCase().includes(q);
  const hasKids = node.children && node.children.length > 0;
  const subLabel = node.division === "Project" && node.sub_division ? node.sub_division : "";
  const roleTitle = node.position || node.role_title || (node.level === 1 ? "Director" : node.level === 2 ? "Manager" : "Staff");

  const button = (
    <button
      type="button"
      disabled={!canManage}
      onClick={() => canManage && onSelect(node.id)}
      data-testid={"org-box-" + node.id}
      data-depth={depth}
      className={"org-box " + (matches ? "" : "opacity-40 grayscale ") + (canManage ? "cursor-pointer" : "cursor-default")}
    >
      <div className="org-box-role">{roleTitle}</div>
      <div className="org-box-sep" />
      <div className="org-box-name" title={node.name}>{node.name}</div>
      <div className="org-box-meta">
        <span className={"org-box-badge " + (DIVISION_COLOR[node.division] || "bg-slate-600 text-white")}>{node.division}</span>
        {(canSeeAllLevels || node.id === viewerId) && (
          <span className="org-box-badge bg-white/20 text-white">Lv{node.level}</span>
        )}
        {subLabel ? <span className="org-box-sub" title={subLabel}>· {subLabel}</span> : null}
        {hasKids ? <span className="org-box-count">↓{node.children.length}</span> : null}
      </div>
    </button>
  );

  // Use React.createElement for the recursive self-call to sidestep Babel JSX traversal overflow.
  const childList = hasKids
    ? React.createElement(
        "ul",
        null,
        node.children.map((c) =>
          React.createElement(OrgChartNode, { key: c.id, node: c, q, canManage, onSelect, depth: depth + 1, viewerId, canSeeAllLevels })
        )
      )
    : null;

  return (
    <li>
      {button}
      {childList}
    </li>
  );
}

export default OrgChartNode;
